import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Directive, Inject, Renderer2, effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RequestService } from '@df/api/request/request.service';
import { ProductListingFactory } from '@df/catalog-ui/listing/product-listing.factory';
import { App } from '@df/core/app';
import { Meta } from '@df/core/meta/meta';
import { TimeoutService } from '@df/ng/timeout.service';
import { NSearch } from '@df/search/df-search.config';
import { SearchComponentDef } from '@df/search/search.component.def';
import { getState } from '@ngrx/signals';
import { AdvancedCommerceSearchStore } from '../../store/advanced-commerce-search.store';
import { AdvancedCommerceSearchResult } from '../advanced-commerce-search-result';
import { AdvancedCommerceSearchService } from '../advanced-commerce-search.service';

@Directive()
export class AdvancedCommerceSearchFormComponentDef extends SearchComponentDef {
    readonly store = inject(AdvancedCommerceSearchStore);

    constructor(
        override readonly app: App,
        @Inject(DOCUMENT) protected override document: Document,
        protected override router: Router,
        protected override searchService: AdvancedCommerceSearchService,
        protected override renderer2: Renderer2,
        protected override requestService: RequestService,
        protected override meta: Meta,
        protected override timeoutService: TimeoutService,
        protected override productListingFactory: ProductListingFactory,
        protected override _ref: ChangeDetectorRef,
        @Inject(NSearch.OPTIONS) protected override config: NSearch.IModuleOptions
    ) {
        super(app, document, router, searchService, renderer2, requestService, meta, timeoutService, productListingFactory, _ref, config);

        // hack for detect changes in signals store
        effect(() => {
            // read store changes and update template
            const state = getState(this.store);

            this.detectChanges();
        });
    }

    override reset(): void {
        super.reset();

        this.detectChanges();
    }

    override goToSearch(): void {
        // cancel term change search request before route resolver search request
        (<any>this.onTermChange).cancel();

        super.goToSearch();
    }

    protected override isValid() {
        return !!(this.term && this.term.length >= this.validTermLength);
    }

    protected override onSearchResult(result: AdvancedCommerceSearchResult | undefined): void {
        this.status.reset();

        super.onSearchResult(result);
    }

    override _onTermChange(): void {
        if (this.isValid()) {
            super._onTermChange();

            // reset search request if term is empty and update autocomplete
            if (!!this.store.searchRequest()?.q && this.term?.length < this.validTermLength) {
                this.store.searchRequestSet(undefined);
                this.store.elementSet('autocomplete_home_recs');
                this.store.dataSet({
                    template: 'autocomplete'
                });
            }
        }
    }
}
